export const LIST_EXPORT_BILLING_REQUEST = 'LIST_EXPORT_BILLING_REQUEST'
export const LIST_EXPORT_BILLING_SUCCESS = 'LIST_EXPORT_BILLING_SUCCESS'
export const LIST_EXPORT_BILLING_FAIL = 'LIST_EXPORT_BILLING_FAIL'

export const DOWNLOAD_EXPORT_BILLING_REQUEST = 'DOWNLOAD_EXPORT_BILLING_REQUEST'
export const DOWNLOAD_EXPORT_BILLING_SUCCESS = 'DOWNLOAD_EXPORT_BILLING_SUCCESS'
export const DOWNLOAD_EXPORT_BILLING_FAIL = 'DOWNLOAD_EXPORT_BILLING_FAIL'

export const EXPORT_EXPORT_BILLING_REQUEST = 'EXPORT_EXPORT_BILLING_REQUEST'
export const EXPORT_EXPORT_BILLING_SUCCESS = 'EXPORT_EXPORT_BILLING_SUCCESS'
export const EXPORT_EXPORT_BILLING_FAIL = 'EXPORT_EXPORT_BILLING_FAIL'
